export default __webpack_public_path__ + "static/media/data1.a52feddf.gif";